module.exports = __webpack_public_path__ + "img/johnoliver6.37e6fb27.jpg";